import { useQuery } from 'react-query';
import { WDAC_PACKAGED_APP_GENERAL_QUERY_KEY } from '../../constants/query';
import useSubscribeStorage from '../../hooks/useSubscribeStorage';
import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';
import WDACPackagedAppService from '../../services/wdac-packaged-app.service';

const usePackagedAppGeneral = ({ packagedAppId }) => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);

  return useQuery([WDAC_PACKAGED_APP_GENERAL_QUERY_KEY, packagedAppId], () =>
    WDACPackagedAppService.getPackagedApp({ globalPackagedAppId: packagedAppId, customerEnvId: customerEnvId }),
  );
};

export default usePackagedAppGeneral;
